import { render, staticRenderFns } from "./slide-section.vue?vue&type=template&id=0ad86e8a"
import script from "./slide-section.vue?vue&type=script&lang=js"
export * from "./slide-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports